import { Field, useField, useForm } from 'react-final-form';
import styles from './FileItem.module.scss';
import { RiCloseFill as RemoveIcon } from 'react-icons/ri'
import { VscFilePdf as PdfIcon } from 'react-icons/vsc';
import { useCallback, useContext, useState } from 'react';
import { UnderwritingFormContext } from '../../context/UnderwritingFormContext';
import { ApplicationContextType, MonthlyReportSteps, UnderwritingSteps, uploadStates } from '../../../../interfaces/interfaces';
import CircularLoader from '../../../../components/common/CircularLoader/CircularLoader';
import MeritoButton from '../../../../components/common/MeritoButtons/MeritoButtons';
import PdfPasswordProtection from './PdfPasswordProtection';
import { getIn } from 'final-form';
import { MonthlyReportFormContext } from '../../../MonthlyReport/context/MonthlyReportFormContext';


type Props = {
    fieldName: string;
    fieldIndex: number;
    stepType: UnderwritingSteps | MonthlyReportSteps;
    outerFieldName: string;
    newUploadedDocIds: number[];
    setNewUploadedDocIds: React.Dispatch<React.SetStateAction<number[]>>;
    deleteDocIds: number[],
    setDeleteDocIds: React.Dispatch<React.SetStateAction<number[]>>;
    isJobProcessing?: boolean;
    contextType?: ApplicationContextType;
}


const FileItem = ({ fieldName, stepType, outerFieldName, setDeleteDocIds, setNewUploadedDocIds, deleteDocIds, newUploadedDocIds, fieldIndex, isJobProcessing, contextType = ApplicationContextType.underwriting }: Props) => {

    const { handleUnderwritingFileJobs, underwritingFileJobs, sendFileJobToApi } = useContext(contextType == ApplicationContextType?.monthlyReport ? MonthlyReportFormContext : UnderwritingFormContext);
    const [showPasswordSuccess, setShowPasswordSuccess] = useState(false);
    const { getState, mutators } = useForm()

    // console.log('fieldName', fieldName);

    const getJobDetails = useCallback((fieldName) => {
        const jobDetails = underwritingFileJobs?.[stepType]?.[fieldName] ?? null;
        // console.log('jobDetails', jobDetails);
        return jobDetails;
    }, [underwritingFileJobs]);

    const handlePasswordSubmit = (password: string, fieldName: string) => {
        setShowPasswordSuccess(true);
        const fileJobDetails = getJobDetails(fieldName);
        sendFileJobToApi(stepType, fieldName, {
            ...fileJobDetails,
            fileMetaData: {
                ...fileJobDetails.fileMetaData,
                password: password,
            },
            status: uploadStates.doneUploading,
        });
    }

    // const { input: { value: fileUploadedValue } } = useField(`${fieldName}`, { subscription: { value: true } });
    // console.log('fieldName', fieldName);
    const fileUploadedValue = getIn(getState()?.values, `${fieldName}`)

    // console.log('fileUploadedValue', fileUploadedValue?.selectedFile?.name);


    return (
        // <Field name={`${fieldName}`}>
        //     {(props) => {
        //         return (
        <>
            {contextType == ApplicationContextType.monthlyReport && fileUploadedValue?.uploadedFile?.isOldFile ?
                null
                :
                <div className={styles.fileItemRootContainer}>

                    <div className={styles.fileItemContainer}>
                        <div className={styles.leftContainer}>
                            <div className={styles.iconContainer}>
                                <PdfIcon />
                            </div>
                            <div className={styles.fileName}>
                                {fileUploadedValue.selectedFile instanceof File ? fileUploadedValue?.selectedFile?.name : fileUploadedValue?.uploadedFile?.fileName}
                            </div>
                        </div>
                        <div className={styles.rightContainer}>
                            {getJobDetails(fieldName)?.status == uploadStates.uploading || isJobProcessing ?
                                <CircularLoader />
                                : <MeritoButton
                                    type='tertiary'
                                    onlyIcon={true}
                                    icon={<RemoveIcon />}
                                    onClick={() => {
                                        // if (isJobProcessing) return;
                                        console.log('outerFieldName', outerFieldName, fieldIndex);
                                        console.log('fileUploadedValue', fileUploadedValue);
                                        setDeleteDocIds(prev => [...prev, fileUploadedValue.uploadedFile?.docId]);
                                        mutators.remove(outerFieldName, fieldIndex);
                                    }}
                                />}
                        </div>
                    </div>

                    {getJobDetails(fieldName)?.status == uploadStates.requiredPassword || showPasswordSuccess ?
                        <PdfPasswordProtection showPasswordSuccess={showPasswordSuccess} fileDetails={fileUploadedValue} handleSubmitPassword={(password) => handlePasswordSubmit(password, fieldName)} />
                        : null}
                </div>}
        </>
    );
}

export default FileItem;